import { render, staticRenderFns } from "./ForumPollMultiple.vue?vue&type=template&id=3b5242e1&scoped=true"
import script from "./ForumPollMultiple.vue?vue&type=script&lang=js"
export * from "./ForumPollMultiple.vue?vue&type=script&lang=js"
import style0 from "./ForumPollMultiple.vue?vue&type=style&index=0&id=3b5242e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5242e1",
  null
  
)

export default component.exports